import { CallApi } from '@signavio/kraken'
import { schema as schemas } from 'normalizr'

import { ADMIN_API_BASE } from '../../callApi'

export const collection = 'adminUserLicense'

export const schema = new schemas.Array(new schemas.Entity(collection))

export const fetch =
  (callApi: CallApi) =>
  ({ userId }: { userId: string }) =>
    callApi(`${ADMIN_API_BASE}/users/${userId}/licenses`, schema)
